<template>
  <section id="company">
    <h5>This is Ahlstrom-Munksjö</h5>

    <h2 class="company-main-headline">A global leader in fiber-based solutions</h2>

    <b-container>
      <div class="information-container">
        <h6>
          A true global presence
        </h6>
        <p>
          Ahlstrom-Munksjö has 6,000 employees worldwide. Operations are conducted in Europe, North and South America as well as Asia. Most production sites are located in Europe, and the head office is in Stockholm, Sweden.
        </p>
      </div>
      <scroll-view :offset="100">
        <template slot-scope="visibility">
          <c-employees key="employees"
                       :visible="visibility.employees"
                       :delay="'2'"/>
        </template>
      </scroll-view>
      <div class="map-continer">
        <img src="../assets/img/karta.png" class="img-fluid">
        <scroll-view :offset="100">
          <template slot-scope="visibility">
            <c-bubble key="bubble1"
                    :visible="visibility.bubble1"
                    :delay="1000"
                    :title="'Europe'"
                    :value="'60%'"
                    :cssClass="'bubble-europe'"/>
            <c-bubble key="bubble2"
                    :visible="visibility.bubble2"
                    :delay="500"
                    :title="'Americas'"
                    :value="'24%'"
                    :cssClass="'bubble-america'"/>
            <c-bubble key="bubble3"
                    :visible="visibility.bubble3"
                    :delay="0"
                    :title="'Asia'"
                    :value="'16%'"
                    :cssClass="'bubble-asia'"/>
          </template>
        </scroll-view>
      </div>
      <div class="btn-container">
        <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.am, 8)"
	        	class="btn btn-black-trans"
		        target="_blank">
					Learn more
				</a>
      </div>

    </b-container>
  </section>
</template>

<script>
  import CEmployees from '../components/Employees.vue';
	import CBubble 		from '../components/Bubble.vue';
  import full from '../assets/pdf/full-report.pdf';
  import am from '../assets/pdf/this-is-am.pdf';

  export default {
    neme: 'Company',
    data() {
      return {
        pdfLinks: {
          'full': full,
          'am': am
        }
      }
    },
    components: {
      CEmployees,
      CBubble
    }
  }
</script>



// WEBPACK FOOTER //
// src/sections/Company.vue